export default "__VITE_ASSET__CINcrMz$__"